import React from 'react'

import { StyledPopup, StyledPopupWrapper } from './index.styled'

export type Props = {
  type: 'lead' | 'form' | 'confirm' | 'profile' | 'welcome' | 'due-date'
  closeIcon?: JSX.Element
  onClose?: () => void
  isOpen?: boolean
  children?: any
  enableAnimation?: boolean
  targetAvatar?: string
  id?: string
  className?: string
  classNameWrapper?: string
  title?: string
}

const Popup = ({
  type = 'lead',
  title,
  closeIcon,
  isOpen = true,
  onClose: onCloseProp,
  children,
  enableAnimation = true,
  targetAvatar,
  id,
  className,
  classNameWrapper,
}: Props) => {
  const onClose = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation()
    if (onCloseProp) onCloseProp()
  }

  return (
    <>
      <StyledPopup
        data-open={isOpen}
        data-type={type}
        data-animation={enableAnimation}
        data-target={targetAvatar}
        id={id}
        className={className}
      >
        <div className="popup-content">
          {!!title && <div className="popup-title">{title}</div>}
          {!!closeIcon && (
            <div className="close-button" onClick={onClose}>
              {closeIcon}
            </div>
          )}
          {children}
        </div>
      </StyledPopup>
      <StyledPopupWrapper
        data-type={type}
        data-open={isOpen}
        onClick={onClose}
        id={id ? `wrapper-${id}` : undefined}
        className={`${classNameWrapper || className || ''}-wrapper`}
      />
    </>
  )
}

export { Popup }
